import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';



@Component({
  selector: 'adf-primary-goal',
  templateUrl: 'primary-goal.html'
})
export class PrimaryGoal {
  @Input() editdata: any;
  @Output() primaryGoalData_evtemit=new EventEmitter();
  primaryGoal: FormGroup;

  public validation_messages = {
   
    'primayr_goal_intention': [
      { type: 'required', message: 'primary goal/intention is required.' }
    ]
  }

 
  constructor(
    public formBuilder: FormBuilder
  ) {
   

    this.primaryGoal = formBuilder.group({
      primayr_goal_intention: ['', Validators.compose([Validators.required])],
    });


  }
  ngOnInit() {
  }
  ngOnChanges() {
   
    this.primaryGoal.controls.primayr_goal_intention.setValue(this.editdata.primary_applicant.primary_details.primayr_goal_intention);
   
  }
  changeLog(event, index: any) {
   
  }

  getValue(){
    this.primaryGoalData_evtemit.emit({primaryGoalFormValue:this.primaryGoal.value,primaryGoalFormValid:this.primaryGoal.valid,primarygoalform:this.primaryGoal});
  }
  populateDataForEdit(data){
    this.primaryGoal.get("primayr_goal_intention").setValue(data); 
  }
}


// WEBPACK FOOTER //
// ./src/pages/adf-page/component/primary-applicant/primary-goal/primary-goal.ts